/**
 * used indirectly by blur admin or it's dependencies
 */
import 'amcharts/dist/amcharts/amcharts';
import 'amcharts/dist/amcharts/serial';
import 'ammap3/ammap/ammap';
import 'ammap3/ammap/maps/js/worldLow';
import 'amcharts/dist/amcharts/themes/light';
import 'amcharts/dist/amcharts/lang/pl';
import 'chart.js';
import 'ckeditor';


// WEBPACK FOOTER //
// ./src/mainModule/js/non-angular-vendors.js